const isNumber = (maybeNumber) => {
  return typeof maybeNumber === "number";
};

const useActualWeight = (controlWeight) => (weight) => {
  return isNumber(weight) ? weight - controlWeight : undefined;
};

export const useDerivedWeights = (data) => {
  const {
    controlWeight,
    contentWeight,
    conformingWeight,
    assembledWeight,
    weightConverter,
    donationPercentage,
    originalReplayWeight: originalReplayWeightLb,
  } = data;

  const actualWeightCalc = useActualWeight(controlWeight);
  const actualContentWeightKg = actualWeightCalc(contentWeight); //Kg
  const actualConformingWeightKg = actualWeightCalc(conformingWeight); // Kg
  const actualAssembledWeightKg = actualWeightCalc(assembledWeight); // Kg

  // prettier-ignore
  const actualNonConformingWeightKg =
    isNumber(actualContentWeightKg) && isNumber(actualConformingWeightKg)
      ? Math.max(actualContentWeightKg - Math.max(actualWeightCalc(assembledWeight || 0), 0) - actualConformingWeightKg, 0)
      : Number.NaN;

  const roundedNonConformingWeightKg = Number.isNaN(actualNonConformingWeightKg)
    ? Number.NaN
    : Number.parseFloat(actualNonConformingWeightKg.toFixed(2));

  let paymentWeight = isNumber(actualConformingWeightKg)
    ? Math.max(weightConverter(actualConformingWeightKg), 0)
    : 0;
  let verifiedReplayWeight;

  // check how much replay weight to remove
  if (originalReplayWeightLb > 0) {
    const calculatedDonationWeight = donationPercentage * actualContentWeightKg;
    const verifiedReplayWeightKg = Math.max(
      calculatedDonationWeight - roundedNonConformingWeightKg,
      0
    );

    // covert to lbs
    verifiedReplayWeight = weightConverter(verifiedReplayWeightKg);
    paymentWeight -= verifiedReplayWeight;
  }

  return {
    actualContentWeight: actualContentWeightKg,
    actualConformingWeight: actualConformingWeightKg,
    actualAssembledWeight: actualAssembledWeightKg,
    paymentWeight,
    verifiedReplayWeight,
    nonConformingWeight:
      // due to rounding to 2dp, we could end up with negative 0
      roundedNonConformingWeightKg === -0 ? 0 : roundedNonConformingWeightKg,
  };
};
